// Shared category/subtype matching for search inputs (nav bar + hero "What" field).
// Single source of truth so both dropdowns can never drift apart.
import serviceType from "../components/pages/servicesType.json";

// Substring-match `query` against categories and subtypes.
// Returns [{ label, value, type: "type1"|"type2", typeLabel, parentType1? }]
export function matchServiceTypes(query, limit = 6) {
  const q = (query || "").trim().toLowerCase();
  if (q.length < 2) return [];
  const suggestions = [];
  for (const cat of serviceType.service_types) {
    if (cat.Service_type1.toLowerCase().includes(q)) {
      suggestions.push({
        label: cat.Service_type1,
        value: cat.Service_type1,
        type: "type1",
        typeLabel: "Category",
      });
    }
    for (const sub of cat.Service_type2) {
      if (sub.toLowerCase().includes(q)) {
        suggestions.push({
          label: sub,
          value: sub,
          type: "type2",
          typeLabel: cat.Service_type1,
          parentType1: cat.Service_type1,
        });
      }
    }
  }
  return suggestions.slice(0, limit);
}

// Exact-label resolution at submit time ("jobs" -> Jobs category).
// Returns { type: "type1"|"type2", value, parentType1? } or null.
export function resolveExactServiceType(query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return null;
  for (const cat of serviceType.service_types) {
    if (cat.Service_type1.toLowerCase() === q) {
      return { type: "type1", value: cat.Service_type1 };
    }
    for (const sub of cat.Service_type2) {
      if (sub.toLowerCase() === q) {
        return { type: "type2", value: sub, parentType1: cat.Service_type1 };
      }
    }
  }
  return null;
}

// Walk UP the taxonomy from any label to the levels above it.
//   "Service Wanted"      -> { category: "Services",    subType: "" }
//   "Single Family Homes" -> { category: "Real Estate", subType: "Residential Properties" }
//   "Services"            -> { category: "Services",    subType: "" }
// Menu selections deliberately clear the levels above them (EventBus.setSubtype
// clears selectedServiceType, setServiceInfo clears both), so a payload built
// from a menu click carries only the deepest level. Callers that need to widen
// a dead search back up to its category recover it here.
export function taxonomyParents(label) {
  const l = (label || "").trim().toLowerCase();
  if (!l) return { category: "", subType: "" };
  for (const cat of serviceType.service_types) {
    if (cat.Service_type1.toLowerCase() === l) {
      return { category: cat.Service_type1, subType: "" };
    }
    for (const sub of cat.Service_type2) {
      if (sub.toLowerCase() === l) {
        return { category: cat.Service_type1, subType: "" };
      }
      const leaves = (cat.Service_type3 || {})[sub] || [];
      if (leaves.some((leaf) => leaf.toLowerCase() === l)) {
        return { category: cat.Service_type1, subType: sub };
      }
    }
  }
  return { category: "", subType: "" };
}
